import { defineComponent as _defineComponent } from 'vue'
import { Ref, onMounted, reactive, ref } from 'vue';
import { useLoader } from '@/composables/loader';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CModal from '@/components/CModal.vue';
import CInput from '@/components/shared/CInput';
import CButton from '@/components/shared/CButton';
import CCustomCheckbox from '@/components/shared/CCustomCheckbox.vue';
import CButtonGroup, { CButtonGroupItem } from '@/components/shared/CButtonGroup';
import { getTeamMemberPermissions, updateTeamMember } from '@/api/team';
import { AccessMode, EntityType, TeamMember } from '@/api/typings/team';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateMemberModal',
  props: {
    member: null
  },
  emits: ["member-updated", "handle-permissions", "cancel"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'member-updated'): void;
    (event: 'handle-permissions', value: TeamMember): void;
    (event: 'cancel'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    member: TeamMember;
};



const accessTypes: CButtonGroupItem[] = [
    {
        label: 'Full access',
        value: AccessMode.FULL
    },
    {
        label: 'Restricted',
        value: AccessMode.RESTRICTED
    }
];

const { execLoadedFn } = useLoader();

const createFormRef: Ref<InstanceType<typeof ValidationObserver> | null> = ref(null);



const memberModel = reactive({
    name: '',
    email: '',
    accessType: AccessMode.FULL,
    manageIntegrations: false
});

const updateMember = async (): Promise<void> => {
    await updateTeamMember(props.member.user.Id, memberModel.accessType, memberModel.manageIntegrations);

    emit('member-updated');
    if (memberModel.accessType == AccessMode.RESTRICTED) emit('handle-permissions', props.member);
};

const cancelHandler = () => emit('cancel');

onMounted(async () => {
    const permissions = await getTeamMemberPermissions(props.member.user.Id);
    memberModel.name = props.member.user.Name;
    memberModel.email = props.member.user.Email;
    memberModel.accessType = props.member.accessMode;
    memberModel.manageIntegrations = permissions.some(
        (p) => p.entityType == EntityType.INTEGRATIONS && p.accessLevel != 0
    );
});

return { __sfc: true,emit, accessTypes, execLoadedFn, createFormRef, props, memberModel, updateMember, cancelHandler, ValidationProvider, ValidationObserver, CModal, CInput, CButton, CCustomCheckbox, CButtonGroup, AccessMode }
}

})